import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple, FuseAnimate} from '@fuse';
import { Chip, Paper, Grid, Button, SwipeableDrawer, Typography, ListItem, Tabs, Tab, FormControl, FormLabel, Divider, ListItemText, List } from '@material-ui/core';
// import Pagination from "material-ui-flat-pagination";

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

import HomeIcon from '@material-ui/icons/Home';
import MenuIcon from '@material-ui/icons/Menu';
import CancelIcon from '@material-ui/icons/Cancel';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import AssitantIcon from '@material-ui/icons/Assistant';
import InfoIcon from '@material-ui/icons/Info';
import BarChartIcon from '@material-ui/icons/BarChart';
// import EditIcon from '@material-ui/icons/Edit';
// import DeleteIcon from '@material-ui/icons/Delete';
// import AddIcon from '@material-ui/icons/Add';
// import CompareIcon from '@material-ui/icons/CompareArrows';
// import ListAltSharpIcon from '@material-ui/icons/List';
// import SaveIcon from '@material-ui/icons/Save';
// import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
    layoutRoot: {},
    tabSelected: {
        borderBottom: '5px solid #4EBAE7',
        background: '#E0F7FA',
        color: 'white'
    },
    listAktivitas: {
        borderBottom: '1px solid #ccc'
    },
    iconBadge: {
        background: 'url(http://'+window.location.host+'/assets/images/badges/1_a.png)',
        backgroundSize: '80%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: 150
    }
});

class ProfilPengguna extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            namaPengguna: '---------',
            bottom: false,
            ListMenu: null,
            email: null,
            routeParams: {
                peran_id: JSON.parse(localStorage.getItem('user')).peran_id,
                token: localStorage.getItem('jwt_token'),
                pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
                instrumen_id: localStorage.getItem('instrumen_id')
            },
            tabsValue: 0
        };
    }

    goTolink = (url) => {
        this.props.history.push(url);
        // alert('oke ganti');
    };

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            tabsValue: value
        })
    }

    handleLogoutButton = (event, data) => {
        // console.log(window.location.pathname.split('/').length);
        // console.log(this.props.location.pathname.split('/'));
        localStorage.setItem('jwt_token', '');
        localStorage.setItem('access_token', '');
        localStorage.setItem('user', '');
        localStorage.setItem('pengguna_id_ops', '');
        localStorage.setItem('aslinya_ops', '');

        // // window.location.reload();
        // if(window.location.pathname.split('/').length === 3){
        //     window.location.href="../"+localStorage.getItem('root_base');

        // }else{
            window.location.href=localStorage.getItem('root_base');
            // window.location.reload(true);

        // }

    }

    componentDidMount = () => {
        this.props.setJudul('Profil Pengguna');

        this.props.getPeran(this.state.routeParams).then((result)=>{
            // 
        });
        // alert('oke');
        console.log(this.props.location.pathname.split('/'));

        if(typeof this.props.location.pathname.split('/')[2] === 'undefined') {
            // does not exist
            // console.log('nggak ada');
            fetch(localStorage.getItem('api_domain')+'/api/AuthPengguna?token='+localStorage.getItem('jwt_token'),{
                method: 'GET'
            })
            .then(res => res.json())
            .then(
                (result) => {
                    // console.log(result);
                    this.setState({
                        namaPengguna: result.user.nama,
                        email: result.user.email
                    },()=>{

                        this.props.getPengguna(this.state.routeParams).then((result)=>{
                            // console.log(this.props.pengguna);
                            
                            // this.setState({
                            //     namaPengguna: result.nama,
                            //     email: result.email
                            // });
                        });
                    });

                    
            });

            this.props.getLogLogin(this.state.routeParams);
            this.props.getLogSimpanJawaban(this.state.routeParams);
            this.props.getBadgePengguna(this.state.routeParams);
        }
        else {
            // does exist
            // console.log(localStorage.getItem('api_domain')+'/api/pengguna/'+this.props.location.pathname.split('/')[2]+'?token='+localStorage.getItem('jwt_token'));
            // fetch(localStorage.getItem('api_domain')+'/api/pengguna/'+this.props.location.pathname.split('/')[2]+'?token='+localStorage.getItem('jwt_token'),{
            //     method: 'GET'
            // })
            // .then(res => res.json())
            // .then(
            //     (result) => {
            //         // console.log(result);
            //         this.setState({
            //             namaPengguna: result.nama,
            //             email: result.email
            //         })
                    
            // });
            this.setState({
                ...this.state,
                routeParams:{
                    ...this.state.routeParams,
                    pengguna_id: this.props.location.pathname.split('/')[2]
                }
            },()=>{
                this.props.getPengguna(this.state.routeParams).then((result)=>{
                    console.log(this.props.pengguna);
    
                    this.setState({
                        namaPengguna: this.props.pengguna.nama,
                        email: this.props.pengguna.email
                    },()=>{
                        // console.log(this.state.namaPengguna);
                    });
                });

                this.props.getLogLogin(this.state.routeParams);
                this.props.getLogSimpanJawaban(this.state.routeParams);
                this.props.getBadgePengguna(this.state.routeParams);
            });
        }

        // this.props.getLogLogin(this.state.routeParams);
        // this.props.getLogSimpanJawaban(this.state.routeParams);
        
    }

    bukaMenuUtama = () => {
        this.setState({ 
            ...this.state, 
            bottom: true
        });
    }

    toggleDrawer = (side, open, option) => () => {
        this.setState({ ...this.state, [side]: open });
    }

    render()
    {
        const {classes} = this.props;
        const {bottom} = this.state;

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                // header={
                //     <div style={{width: '100%'}}>
                //         <div style={{minHeight: 10, width: '100%', background: '#4EBBE8', overflow: 'auto', maxHeight: '43px', display: 'inline-flex'}}>
                //             <Chip
                //                 icon={<HomeIcon/>}
                //                 label=""
                //                 className={this.props.classes.chip}
                //                 color="primary"
                //                 style={{justifyContent: 'start', marginLeft: 0, padding: 5, borderRadius: 0, borderRight: '1px solid #ccc', paddingLeft: '0px', paddingRight: '0px'}}
                //                 onClick={()=>{this.goTolink('/Beranda')}}
                //                 />
                //             <Chip
                //                 label="> Manajemen Pengguna"
                //                 className={this.props.classes.chip}
                //                 color="primary"
                //                 onClick={()=>{this.goTolink('/ManajemenPengguna')}}
                //                 style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                //             />
                //             <Chip
                //                 label={"> Profil "+this.state.namaPengguna+""}
                //                 className={this.props.classes.chip}
                //                 color="secondary"
                //                 // onClick={()=>{this.goTolink('/ManajemenPengguna')}}
                //                 style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                //             />
                //         </div>
                //         <div className="p-16" style={{border: '0px solid #ccc', width: '100%'}}>
                //             <Grid container spacing={16}>
                //                 <Grid item xs={2} sm={1}>
                //                     <Paper style={{width: 65, height: 65, background: 'url(/assets/images/avatars/avatar.gif)',backgroundSize: '100%', margin: 'auto'}}>
                //                     </Paper>
                //                 </Grid>
                //                 <Grid item xs={8} sm={8}>
                //                     <h1 style={{fontSize: 25, fontFamily: 'Helvetica'}}>{this.state.namaPengguna}</h1>
                //                 </Grid>
                //                 <Grid item xs={2} sm={3} style={{textAlign: 'right'}}>
                //                     {/* <Button size="small" variant="outlined" style={{margin: 'auto'}} className="buttonTambah">
                //                         <AddIcon /> Tambah Pengguna
                //                     </Button> */}
                //                     <Button size="small" variant="outlined" style={{margin: 'auto', minWidth: '40px'}} className="buttonMenu" onClick={this.bukaMenuUtama}>
                //                         <MenuIcon />
                //                     </Button>
                //                 </Grid>
                //             </Grid>
                //         </div>
                //     </div>   
                // }
                content={
                    <FuseAnimate
                        animation="transition.slideRightBigIn"
                        duration={400}
                        delay={400}
                    >
                    <div style={{width: '100%'}} className="konten-utama">
                        
                        <div className="p-16" style={{border: '0px solid #ccc', width: '100%', background: 'url(http://'+window.location.host+'/assets/images/backgrounds/pencil-book.jpg)', marginTop: '-1px', backgroundPosition: 'center', backgroundSize: 'cover', minHeight: 130}}>
                            <Grid container spacing={16}>
                                <Grid item xs={2} sm={1}>
                                    <Paper style={{width: 65, height: 65, background: 'url(http://'+window.location.host+'/assets/images/avatars/avatar.gif)',backgroundSize: '100%', margin: 'auto'}}>
                                    </Paper>
                                </Grid>
                                <Grid item xs={8} sm={8} style={{paddingLeft: 20}}>
                                    <h1 style={{fontSize: 20, fontFamily: 'Helvetica', color: '#434343'}}>{this.state.namaPengguna}</h1>
                                    <h4 style={{fontSize: 15, color: '#434343'}}>Username: {this.state.email}</h4>
                                    <h4 style={{fontSize: 15, color: '#434343'}}>Peran: {this.props.peran.nama}</h4>
                                </Grid>
                                <Grid item xs={2} sm={3} style={{textAlign: 'right'}}>
                                    {/* <Button size="small" variant="outlined" style={{margin: 'auto'}} className="buttonTambah">
                                        <AddIcon /> Tambah Pengguna
                                    </Button> */}
                                    <Button size="small" variant="contained" color="primary" style={{margin: 'auto', minWidth: '40px'}} className="buttonMenu" onClick={this.bukaMenuUtama}>
                                        <MenuIcon style={{color:'white'}} />
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>

                        <div style={{minHeight: 10, width: '100%', background: '#4EBBE8', overflow: 'auto', maxHeight: '42px', display: 'inline-flex'}}>
                            <Chip
                                icon={<HomeIcon/>}
                                label=""
                                className={this.props.classes.chip}
                                color="primary"
                                style={{justifyContent: 'start', marginLeft: 0, padding: 5, borderRadius: 0, borderRight: '1px solid #ccc', paddingLeft: '0px', paddingRight: '0px'}}
                                onClick={()=>{this.goTolink('/Beranda')}}
                                />
                            {JSON.parse(localStorage.getItem('user')).peran_id === 10 &&
                            <Chip
                                label="> Manajemen Pengguna"
                                className={this.props.classes.chip}
                                color="primary"
                                onClick={()=>{this.goTolink('/ManajemenPengguna')}}
                                style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                            />
                            }
                            <Chip
                                label={"> Profil "+this.state.namaPengguna+""}
                                className={this.props.classes.chip}
                                color="secondary"
                                // onClick={()=>{this.goTolink('/ManajemenPengguna')}}
                                style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                            />
                        </div>
                        
                        {/* <Paper className="p-8 paperPengembangan">
                            <Typography variant="display2" style={{color:'white'}}>
                                Menu ini sedang dalam pengembangan
                            </Typography>
                            <Typography variant="headline" style={{color:'white'}}>
                                Tunggu Kami sedikit lagi ya, di versi selanjutnya :)
                            </Typography>
                        </Paper> */}
                        <Tabs
                            value={this.state.tabsValue}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={this.handleChangeTab}
                        >
                            <Tab icon={<PersonPinIcon />} label="Profil" classes={{ selected: classes.tabSelected }}/>
                            <Tab icon={<BarChartIcon />} label="Aktivitas" classes={{ selected: classes.tabSelected }}/>
                            <Tab icon={<AssitantIcon />} label="Penghargaan" classes={{ selected: classes.tabSelected }}/>
                        </Tabs>
                        {/* <Paper className="p-8"> */}
                        {this.state.tabsValue === 0 && 
                        // <FuseAnimate
                        //     animation="transition.slideUpIn"
                        //     duration={500}
                        //     delay={200}
                        // >
                        <Paper className="p-8 tabContent">
                            <Paper className="p-16" style={{background: '#F1F8E9'}}>
                                <Grid container>
                                    <Grid item xs={12} sm={1}>
                                        <InfoIcon style={{fontSize:35, color: '#9CCC65'}}/>
                                    </Grid>
                                    <Grid item xs={12} sm={11}>
                                        <Typography variant="caption">
                                            Semua identitas yang ditampilkan pada form dibawah ini bersumber dari Data Pokok Pendidikan (Dapodik). 
                                            <br/>Silakan lakukan penyesuaian pada aplikasi Dapodik sekolah Anda apabila ada ketidaksesuaian
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Paper>
                            <Grid container>
                                <Grid item xs={12} sm={6} className="kolomProfilPengguna">
                                    <Grid container>
                                        <Grid item xs={12} style={{marginTop: 10, borderBottom: '0px solid #ccc'}}>
                                            <FormControl component="fieldset" className={classes.formControl} style={{marginTop: 10, width: '100%'}}>
                                                <FormLabel component= "legend">Nama</FormLabel>
                                                <Paper className="paperFieldPengguna p-8">
                                                    <Typography variant="subheading" className="fieldPengguna">{this.props.pengguna.nama}</Typography>
                                                </Paper>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} style={{marginTop: 10, borderBottom: '0px solid #ccc'}}>
                                            <FormControl component="fieldset" className={classes.formControl} style={{marginTop: 10, width: '100%'}}>
                                                <FormLabel component= "legend">Email</FormLabel>
                                                <Paper className="paperFieldPengguna p-8">
                                                    <Typography variant="subheading" className="fieldPengguna">{this.props.pengguna.email}</Typography>
                                                </Paper>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} style={{marginTop: 10, borderBottom: '0px solid #ccc'}}>
                                            <FormControl component="fieldset" className={classes.formControl} style={{marginTop: 10, width: '100%'}}>
                                                <FormLabel component= "legend">Peran</FormLabel>
                                                <Paper className="paperFieldPengguna p-8">
                                                    <Typography variant="subheading" className="fieldPengguna">{this.props.peran.nama}</Typography>
                                                </Paper>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} style={{marginTop: 10, borderBottom: '0px solid #ccc'}}>
                                            <FormControl component="fieldset" className={classes.formControl} style={{marginTop: 10, width: '100%'}}>
                                                <FormLabel component= "legend">Bidang Studi / Tingkat Kelas</FormLabel>
                                                <Paper className="paperFieldPengguna p-8">
                                                    <Typography variant="subheading" className="fieldPengguna">&nbsp;{this.props.pengguna.bidang_studi_id_str}</Typography>
                                                </Paper>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={6} className="kolomProfilPengguna">
                                    <Grid container>
                                        <Grid item xs={12} style={{marginTop: 10, borderBottom: '0px solid #ccc'}}>
                                            <FormControl component="fieldset" className={classes.formControl} style={{marginTop: 10, width: '100%'}}>
                                                <FormLabel component= "legend">NIK</FormLabel>
                                                <Paper className="paperFieldPengguna p-8">
                                                    <Typography variant="subheading" className="fieldPengguna">&nbsp;{this.props.pengguna.nik}</Typography>
                                                </Paper>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} style={{marginTop: 10, borderBottom: '0px solid #ccc'}}>
                                            <FormControl component="fieldset" className={classes.formControl} style={{marginTop: 10, width: '100%'}}>
                                                <FormLabel component= "legend">NUPTK</FormLabel>
                                                <Paper className="paperFieldPengguna p-8">
                                                    <Typography variant="subheading" className="fieldPengguna">&nbsp;{this.props.pengguna.nuptk}</Typography>
                                                </Paper>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} style={{marginTop: 10, borderBottom: '0px solid #ccc'}}>
                                            <FormControl component="fieldset" className={classes.formControl} style={{marginTop: 10, width: '100%'}}>
                                                <FormLabel component= "legend">NISN</FormLabel>
                                                <Paper className="paperFieldPengguna p-8">
                                                    <Typography variant="subheading" className="fieldPengguna">&nbsp;{this.props.pengguna.nisn}</Typography>
                                                </Paper>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} style={{marginTop: 10, borderBottom: '0px solid #ccc'}}>
                                            <FormControl component="fieldset" className={classes.formControl} style={{marginTop: 10, width: '100%'}}>
                                                <FormLabel component= "legend">Tanggal Lahir</FormLabel>
                                                <Paper className="paperFieldPengguna p-8">
                                                    <Typography variant="subheading" className="fieldPengguna">&nbsp;{this.props.pengguna.tanggal_lahir}</Typography>
                                                </Paper>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                
                            </Grid>
                        </Paper>
                        // </FuseAnimate>
                        }
                        {this.state.tabsValue === 1 && 
                        // <FuseAnimate
                        //     animation="transition.slideUpIn"
                        //     duration={500}
                        //     delay={200}
                        // >
                        <Paper className="p-8 tabContent">
                            {/* <Paper className="p-8 paperPengembangan">
                                <Typography variant="display2" style={{color:'white'}}>
                                    Menu ini sedang dalam pengembangan
                                </Typography>
                                <Typography variant="headline" style={{color:'white'}}>
                                    Tunggu Kami sedikit lagi ya, di versi selanjutnya :)
                                </Typography>
                            </Paper> */}
                            <Paper className="p-8">
                                <Typography variant="title" style={{color: '#0277BD'}}>
                                    Aktivitas Login
                                    <Divider/>
                                    <br/>
                                    <List component="small">
                                        {/* <ListItem button color="primary" className={classes.listAktivitas}>
                                            <ListItemText primary="5 Maret 2019, 19:00 - PMP Daring/PMP Desktop/Android/IOS" secondary="LOGIN LANGSUNG"/>
                                        </ListItem>
                                        <ListItem button color="primary" className={classes.listAktivitas}>
                                            <ListItemText primary="6 Maret 2019, 01:20 - PMP Daring/PMP Desktop/Android/IOS" secondary="LOGIN LANGSUNG"/>
                                        </ListItem> */}
                                        {this.props.log_login.rows.map((option)=>{
                                            return (
                                                <ListItem button color="primary" className={classes.listAktivitas}>
                                                    <ListItemText primary={option.create_date + " - " + option.media} secondary={option.jenis_login}/>
                                                </ListItem>
                                            )
                                        })}
                                        {this.props.log_login.total < 1 && 
                                        <ListItem disabled color="primary" className={classes.listAktivitas}>
                                            <ListItemText primary={this.props.pengguna.nama + " Belum pernah login"}/>
                                        </ListItem>}
                                    </List>
                                </Typography>
                            </Paper>
                            <br/>
                            <Paper className="p-8">
                                <Typography variant="title" style={{color:'#0277BD'}}>
                                    Aktivitas Pengisian Kuesioner
                                    <Divider/>
                                    <br/>
                                    <List component="small">
                                        {/* <ListItem button color="primary" className={classes.listAktivitas}>
                                            <ListItemText primary="5 Maret 2019, 19:00 - PMP Daring/PMP Desktop/Android/IOS" secondary="Kategori A, B, D"/>
                                        </ListItem>
                                        <ListItem button color="primary" className={classes.listAktivitas}>
                                            <ListItemText primary="6 Maret 2019, 01:20 - PMP Daring/PMP Desktop/Android/IOS" secondary="Kategori C, F"/>
                                        </ListItem> */}
                                        {this.props.log_simpan_jawaban.rows.map((option)=>{
                                            return (
                                                <ListItem button color="primary" className={classes.listAktivitas}>
                                                    <ListItemText primary={option.create_date + " - " + option.media}/>
                                                </ListItem>
                                            )
                                        })}
                                        {this.props.log_simpan_jawaban.total < 1 && 
                                        <ListItem disabled color="primary" className={classes.listAktivitas}>
                                            <ListItemText primary={this.props.pengguna.nama + " Belum pernah mengisi kuesioner"}/>
                                        </ListItem>}
                                    </List>
                                </Typography>
                            </Paper>
                        </Paper>
                        // </FuseAnimate>
                        }
                        {this.state.tabsValue === 2 && 
                        // <FuseAnimate
                        //     animation="transition.slideUpIn"
                        //     duration={500}
                        //     delay={200}
                        // >
                        <Paper className="p-8 tabContent">
                            {/* <Paper className="p-8 paperPengembangan">
                                <Typography variant="display2" style={{color:'white'}}>
                                    Menu ini sedang dalam pengembangan
                                </Typography>
                                <Typography variant="headline" style={{color:'white'}}>
                                    Tunggu Kami sedikit lagi ya, di versi selanjutnya :)
                                </Typography>
                            </Paper> */}
                            <Grid container spacing={8}>
                                {/* <Grid item xs={12} sm={6}>
                                    <Paper>
                                        <Grid container>
                                            <Grid item xs={8} className="p-8">
                                                <Typography variant="title">
                                                    Kemajuan 25%
                                                </Typography>
                                                <Divider/>
                                                <br/>
                                                <Typography variant="body1">
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam laoreet ipsum nec sollicitudin vehicula.
                                                </Typography>
                                            </Grid>
                                            <Grid xs={4} className={classes.iconBadge}>
                                                &nbsp;
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Paper>
                                        <Grid container>
                                            <Grid item xs={8} className="p-8">
                                                <Typography variant="title">
                                                    Kemajuan 50%
                                                </Typography>
                                                <Divider/>
                                                <br/>
                                                <Typography variant="body1">
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam laoreet ipsum nec sollicitudin vehicula.
                                                </Typography>
                                            </Grid>
                                            <Grid xs={4} className={classes.iconBadge} style={{background:'url(http://'+window.location.host+'/assets/images/badges/2_a.png)',backgroundSize: '80%',backgroundPosition: 'center',backgroundRepeat: 'no-repeat',}}>
                                                &nbsp;
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Paper>
                                        <Grid container>
                                            <Grid item xs={8} className="p-8">
                                                <Typography variant="title">
                                                    Kemajuan 75%
                                                </Typography>
                                                <Divider/>
                                                <br/>
                                                <Typography variant="body1">
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam laoreet ipsum nec sollicitudin vehicula.
                                                </Typography>
                                            </Grid>
                                            <Grid xs={4} className={classes.iconBadge} style={{background:'url(http://'+window.location.host+'/assets/images/badges/3_a.png)',backgroundSize: '80%',backgroundPosition: 'center',backgroundRepeat: 'no-repeat',}}>
                                                &nbsp;
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Paper className="paperBadgeInduk">
                                        <Grid container>
                                            <Grid item xs={8} className="p-8">
                                                <Typography variant="title">
                                                    100%!!
                                                </Typography>
                                                <Divider/>
                                                <br/>
                                                <Typography variant="body1">
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam laoreet ipsum nec sollicitudin vehicula.
                                                </Typography>
                                            </Grid>
                                            <Grid xs={4} className={classes.iconBadge} style={{background:'url(http://'+window.location.host+'/assets/images/badges/4_a.png)',backgroundSize: '80%',backgroundPosition: 'center',backgroundRepeat: 'no-repeat',}}>
                                                &nbsp;
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid> */}
                                {this.props.badge_pengguna.rows.map((option)=>{
                                    
                                    let imgLogo = option.jenis_badge_id+'_a.png';
                                    let warnaBg = '#EEEEEE';
                                    let warnaText = '#BDBDBD';
                                    if(option.badge_pengguna_id){
                                        imgLogo = option.jenis_badge_id+'.png';
                                        warnaBg = '#ffffff';
                                        warnaText = '#434343';
                                    }

                                    return (
                                        <Grid item xs={12} sm={6}>
                                            <Paper className="paperBadgeInduk" style={{background:warnaBg}}>
                                                <Grid container>
                                                    <Grid item xs={8} className="p-8">
                                                        <Typography variant="title" style={{color:warnaText}}>
                                                            {option.nama}
                                                        </Typography>
                                                        {/* <Divider/> */}
                                                        <br/>
                                                        <Typography variant="body1" style={{color:warnaText}}>
                                                            {option.keterangan}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid xs={4} className={classes.iconBadge} style={{background:'url(http://'+window.location.host+'/assets/images/badges/'+imgLogo+')',backgroundSize: '75%',backgroundPosition: 'center',backgroundRepeat: 'no-repeat',}}>
                                                        &nbsp;
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        </Grid>
                                    )
                                })}
                            </Grid>
                        </Paper>
                        // </FuseAnimate>
                        }
                        {/* </Paper> */}

                        <SwipeableDrawer
                            anchor="bottom"
                            open={bottom}
                            onClose={this.toggleDrawer('bottom', false, null)}
                            onOpen={this.toggleDrawer('bottom', true, null)}
                        >
                            <div style={{padding: 0, minHeight: 100, maxHeight: 400, overflow: 'auto'}}>
                                <ListItem button key="Tukar" style={{textAlign: 'left', background: '#ff5c8d'}} onClick={this.handleLogoutButton}>
                                    <CancelIcon style={{color:'white'}}/> <Typography style={{color:'white'}}>&nbsp;Keluar Aplikasi</Typography>
                                </ListItem>
                            </div>
                        </SwipeableDrawer>
                    </div>
                    </FuseAnimate>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getPengguna: Actions.getPengguna,
        getLogLogin: Actions.getLogLogin,
        getLogSimpanJawaban: Actions.getLogSimpanJawaban,
        tukarPengguna: Actions.tukarPengguna,
        getPeran: Actions.getPeran,
        getBadgePengguna: Actions.getBadgePengguna,
        setJudul: Actions.setJudul
    }, dispatch);
}

function mapStateToProps({ Pengguna }) {

    return {
        pengguna: Pengguna.pengguna,
        hasil_tukar_pengguna: Pengguna.hasil_tukar_pengguna,
        log_login: Pengguna.log_login,
        log_simpan_jawaban: Pengguna.log_simpan_jawaban,
        badge_pengguna: Pengguna.badge_pengguna,
        peran: Pengguna.peran
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ProfilPengguna)));



// WEBPACK FOOTER //
// ./src/main/content/Pengaturan/ProfilPengguna.js